import {
  INIT_DATA,
  SET_SHOW_FIND_FRAME,
  UPDATE_FRAME_SPLIT_DATA,
  UPDATE_SHOT_CHANGE_ERROR_DATA,
  UPDATE_FRAME_GAP_DATA,
} from '../types';
import TimeUtils from '../../helper/TimeUtils';
import DataObj from '../../class/DataObj';
import ShotChangeErrorObj from '../../class/ShotChangeErrorObj';
import EveryTCobj from '../../class/EveryTCobj';
import WaveformView from '../../components/drogable/WaveformView';
import ShotChangeUtils from '../../helper/ShotChangeUtils';
import MathUtils from '../../helper/MathUtils';

/**
 * 檢查 Shot Change 要顯示 list
 *
 * @param {*} outObj
 */
export const updateShotChangeData =
  (_data, _shotSecondChangeArray) => (dispatch) => {
    const data = _data.filter((obj) => obj.In !== '');
    const videoFps = parseFloat(TimeUtils.getFPS());

    var halfSecondFrame = parseFloat((videoFps / 2).toFixed());
    if (videoFps === 25) {
      halfSecondFrame = 12;
    }
    // const halfSecondFrame = 12;

    // let filterArray = shotChangeArray;
    // 產出 frame array
    let shotChange_frame_Array = ShotChangeUtils.shotChangeToFrameArray(
      _shotSecondChangeArray,
      videoFps
    );

    /***
    先產生臨時的資料 
    */
    let allROWoBJ_shot_frame_Array = []; // EveryTCobj 列表:所有資料的集合
    data.forEach(function (qdata, qindex) {
      let ROWoBJ = new DataObj(qdata);

      var startSecond = parseFloat(ROWoBJ.start);
      var endSecond = parseFloat(ROWoBJ.end);

      // if(ROWoBJ.isIgnoreShotchange === true){
      //   // 不處理

      // }else
      if (startSecond !== 0 && endSecond !== 0) {
        //進入點
        let inEveryTCobj = new EveryTCobj({
          type: 'tc_in',
          second: parseFloat(startSecond),
          // frame: startSecond * videoFps   TimeUtils.timeString_convertTo_frame(currentObj.In),
          frame: TimeUtils.timeString_convertTo_frame(ROWoBJ.In),
          index: qindex,
          timeString: ROWoBJ.In,
          inList: [],
          outList: [],
          isIgnoreShotchange: ROWoBJ.isIgnoreShotchange,
          isInShotChangeActive: ROWoBJ.isInShotChangeActive,
          isOutShotChangeActive: ROWoBJ.isOutShotChangeActive,
        });

        allROWoBJ_shot_frame_Array.push(inEveryTCobj);

        //消失點
        let outEveryTCobj = new EveryTCobj({
          type: 'tc_out',
          second: parseFloat(endSecond),
          // frame: endSecond * videoFps,
          frame: TimeUtils.timeString_convertTo_frame(ROWoBJ.Out),
          index: qindex,
          timeString: ROWoBJ.Out,
          inList: [],
          outList: [],
          isIgnoreShotchange: ROWoBJ.isIgnoreShotchange,
          isInShotChangeActive: ROWoBJ.isInShotChangeActive,
          isOutShotChangeActive: ROWoBJ.isOutShotChangeActive,
        });

        allROWoBJ_shot_frame_Array.push(outEveryTCobj);
      }
    });

    let shotChange_flag_Array = []; //EveryTCobj 列表 : 所有shotChange 周圍的集合
    //shotChangeArray.forEach(function(shotSecond,sindex) {
    shotChange_frame_Array.forEach((shotFram, sindex) => {
      const _timestring = TimeUtils.convertFramesToTimestring(shotFram);

      //產生shotFlag\
      const everyShotobj = new EveryTCobj({
        type: 'shotFlag',
        second: parseFloat(_shotSecondChangeArray[sindex]),
        frame: shotFram,
        timeString: _timestring,
        index: sindex,
        inList: [],
        outList: [],
        timeString: '',
        isIgnoreShotchange: false,
        isInShotChangeActive: false,
        isOutShotChangeActive: false,
      });

      shotChange_flag_Array.push(everyShotobj);
    });

    // console.log('shotChange_flag_Array', shotChange_flag_Array);

    shotChange_flag_Array.forEach(function (_everyTCobj) {
      //產生shotFlag\
      let targetFrame = _everyTCobj.frame;

      let top = targetFrame - halfSecondFrame;
      let bottom = targetFrame + halfSecondFrame;
      // let topSecond =  targetSecond - 0.5;
      // let bottomSecond =  targetSecond + 0.5;

      //有包含有包含

      //get list 透過 frame
      _everyTCobj.inList = allROWoBJ_shot_frame_Array.filter((RowObj) => {
        // obj.type === 'tc_in' && top < obj.frame && bottom > obj.frame

        // 檢查 tc_in: top  貼齊
        if (RowObj.type === 'tc_in' && RowObj.frame !== targetFrame) {
          if (top < RowObj.frame && bottom > RowObj.frame) {
            // 進入到top 與 bottom 中間
            // 返回不合法的shotChange
            return RowObj;
          }
        }
      });

      _everyTCobj.outList = allROWoBJ_shot_frame_Array.filter((RowObj) => {
        // obj.type === 'tc_in' && top < obj.frame && bottom > obj.frame

        // 檢查 tc_in: top  貼齊
        if (RowObj.type === 'tc_out') {
          if (top < RowObj.frame && bottom > RowObj.frame) {
            // Out TC 要在shotchang 往前2f
            // 返回不合法的shotChange
            if (parseInt(RowObj.frame) !== parseInt(targetFrame - 2)) {
              return RowObj;
            }
          }
        }
      });
    });

    //所有有問題的shotChange 資料
    shotChange_flag_Array = shotChange_flag_Array.filter(
      (obj) => obj.inList.length > 0 || obj.outList.length > 0
    );

    let newTarget = [];
    //檢查出所帶有的inList  outList 有不對規則之處
    //以2f 到半秒之間的距離(halfSecondFrame)
    shotChange_flag_Array.forEach(function (_scObj) {
      //const {inList,outList} = shotFlagObj;

      const shotChangeSecond = _scObj.second;

      //產生shotFlag\
      const { inList, outList } = _scObj;

      //最後要呈現的資料
      var finalFram = 0;

      //檢查  inList 裡面有沒有錯誤的資料，有錯誤的話就拉出來
      inList.forEach(function (inObj, index) {
        let shotChangeErrorObj = new ShotChangeErrorObj({});
        //
        //取出距離 用frame計算
        const distance = ShotChangeUtils.getDistanceByTimeString(_scObj, inObj);

        if (parseInt(_scObj.frame) - parseInt(inObj.frame) < 0) {
          //In-TC 在  shotChange 的後面
          //finalFram = shotFlagObj.frame - Math.abs(distance);
          if (
            parseInt(inObj.frame) >
            parseInt(_scObj.frame) + halfSecondFrame / 2
          ) {
            // 到SC 後面12格
            finalFram = parseInt(_scObj.frame) + halfSecondFrame;
          } else {
            //到sc
            finalFram = parseInt(_scObj.frame);
          }
        } else {
          //In-TC 在  shotChange 的前面
          if (
            parseInt(inObj.frame) >
            parseInt(_scObj.frame) - halfSecondFrame / 2
          ) {
            // 如果 In-TC的位置大於 (shotChange扣掉12f的一半) 則往前
            // 到SC
            finalFram = parseInt(_scObj.frame);
          } else {
            //到sc 前方12格
            finalFram = parseInt(_scObj.frame) - halfSecondFrame;
          }
        }

        // TC 要跑的距離
        const moveFrameCount = finalFram - inObj.frame;

        if (Math.abs(distance) > 0) {
          shotChangeErrorObj.setData(
            'In',
            inObj.index,
            finalFram,
            inObj.second,
            shotChangeSecond,
            get_MoveArror_and_wayTitle(moveFrameCount).moveArror,
            get_MoveArror_and_wayTitle(moveFrameCount).wayTitle,
            parseFloat(Math.abs(moveFrameCount).toFixed()),
            _scObj,
            _scObj.timeString,
            inObj.isIgnoreShotchange,
            inObj.isInShotChangeActive, //  是否修改過In
            inObj.isOutShotChangeActive //  是否修改過Out
          );

          newTarget.push(shotChangeErrorObj);
        }

        if (index === 4) {
          //
        }
      });

      //檢查  outList
      outList.forEach(function (outObj) {
        let shotChangeErrorObj = new ShotChangeErrorObj({});
        //
        //取出距離
        const distance = ShotChangeUtils.getDistanceByTimeString(
          _scObj,
          outObj
        );

        // TC 要跑的距離
        let moveFrameCount = 0;

        //如果距離違法
        // if (  Math.abs(distance) < Math.round(halfSecondFrame).toFixed()
        // ) {
        // if(Math.abs(distance) > 2 && Math.abs(distance) < halfSecondFrame){
        //往左移或往右移的決定
        if (_scObj.frame - outObj.frame > 0) {
          /**
           * Out-TC 在  shotChange 的前面
           */
          //finalFram = shotFlagObj.frame - Math.abs(distance);
          if (outObj.frame >= _scObj.frame - halfSecondFrame / 2) {
            // Out-TC 如果是在 (shotChange 半秒的一半) 與 shotChange 之間
            // 到SC 前面兩格
            finalFram = parseInt(_scObj.frame) - 2;

            //
          } else {
            //到sc前面 12f
            finalFram = _scObj.frame - halfSecondFrame;
          }
          // 距離
          moveFrameCount = finalFram - parseInt(outObj.frame);
        } else if (_scObj.frame === outObj.frame) {
          /**
           *  Out tc 壓到 shot change
           */

          //到sc前面
          finalFram = _scObj.frame - 2;
          // 距離
          moveFrameCount = -2;
        } else {
          /**
           * Out tc 如果在 shot change 後方 :
           *
           * 6f 以內要移動到 shot change 前面兩個f
           * 如果大於6f 就要在 shot change 後 12f
           */
          if (outObj.frame - _scObj.frame <= halfSecondFrame / 2) {
            // 6f 以內
            //到sc前面
            finalFram = _scObj.frame - 2;
            // 距離
            moveFrameCount =
              parseInt(_scObj.frame - 2) - parseInt(outObj.frame);
          } else {
            // 到SC 後面12格
            finalFram = _scObj.frame + halfSecondFrame;

            // 距離
            moveFrameCount = _scObj.frame + halfSecondFrame - outObj.frame;
          }
        }

        if (Math.abs(distance) > 0 || Math.abs(distance) === 0) {
          shotChangeErrorObj.setData(
            'Out',
            outObj.index,
            finalFram,
            outObj.second,
            shotChangeSecond,
            get_MoveArror_and_wayTitle(moveFrameCount).moveArror,
            get_MoveArror_and_wayTitle(moveFrameCount).wayTitle,
            parseFloat(Math.abs(moveFrameCount).toFixed()),
            _scObj,
            _scObj.timeString,
            outObj.isIgnoreShotchange,
            outObj.isInShotChangeActive, //  是否修改過In
            outObj.isOutShotChangeActive //  是否修改過Out
          );

          newTarget.push(shotChangeErrorObj);
        }
        // }
      });

      // TODO: 檢查 如果今天很多的sh在outTC後面的話，選定一個最近的來做處理
      // let final
      if (outList.length > 1) {
        // const afterFargetFrameList = _everyTCobj.outList.filter(
        //   (eObj) => parseFloat(eObj.frame) > parseFloat(targetFrame)
        // );
        // if (afterFargetFrameList.length > 1) {
        //   const result = afterFargetFrameList.sort(function (a, b) {
        //     return a.frame - b.frame;
        //   });
        //   _everyTCobj.outList = result[0];
        // }
      }
    });

    // 重整
    function groupBy(array, f) {
      let groups = {};
      array.forEach(function (o) {
        let group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function (group) {
        return groups[group];
      });
    }
    let GroupBy_outTime = groupBy(newTarget, function (item) {
      return [item.outTime];
    });
    // 處理 outTime 的時間點
    newTarget = GroupBy_outTime.map((objArray, i) => {
      if (objArray.length === 1) {
        return objArray[0];
      } else {
        // 檢查有大餘 second 的 shotChangeSecond ，確認 shotchange 在後面
        const tmpArray = objArray.filter(
          (obj) => obj.shotChangeSecond > obj.second
        );

        if (tmpArray.length === 1) {
          // 如果只有一個 就直接回覆
          return tmpArray[0];
        } else if (tmpArray.length === 0) {
          // 如果都沒有，那就是shotchange都在前面
          return objArray[0];
        }

        if (tmpArray.length > 1) {
          // 後面有兩個以上的shotchange
          // 進行比較
          tmpArray.sort(function (x, y) {
            return x.shotChangeSecond - y.shotChangeSecond;
          });

          return tmpArray[0];
        }

        return objArray[0];
      }
    });

    newTarget.sort(function (a, b) {
      return a.rowIndex - b.rowIndex;
    });

    dispatch({
      type: UPDATE_SHOT_CHANGE_ERROR_DATA,
      payload: newTarget,
    });

    //清空原本的ShotChange 欄位
    newTarget.forEach(function (shotChangeErrorObj, sindex) {
      let rowData = new DataObj(data[shotChangeErrorObj.rowIndex]);
      rowData.setTSubType(WaveformView.projectSubType);

      // if (rowData.isIgnoreShotchange !== true) {

      // }
      rowData.setShotChange(''); // 設定顯示
      rowData.ShotChangeArray = [];
      // 帶來的DATA
      data[shotChangeErrorObj.rowIndex] = rowData;
    });

    //產生一個array 裡面包含獨特的DataObj id
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    let DataObj_index_array = [];
    newTarget.forEach(function (shotChangeErrorObj, sindex) {
      DataObj_index_array.push(shotChangeErrorObj.rowIndex);
    });

    const uniqueDataObj_index_array = DataObj_index_array.filter(onlyUnique);

    uniqueDataObj_index_array.forEach(function (uID) {
      let rowData = new DataObj(data[uID]);
      rowData.setTSubType(WaveformView.projectSubType);

      // if (rowData.isIgnoreShotchange !== true) {

      // }
      // 把每一個有問題的 Row 資料取出
      const errorShotArray = newTarget.filter(
        (shotChangeErrorObj) =>
          parseFloat(shotChangeErrorObj.rowIndex) === parseFloat(uID)
      );

      // 把對應的 Title
      let chotArray = [];
      // errorShotArray.forEach(function (ErrorObj) {
      //   chotArray.push(ErrorObj.errorShotChangeTitle[0]);
      // });
      errorShotArray.forEach(function (ErrorObj) {
        chotArray.push(`${ErrorObj.shotchangeObj.timeString}`);
        if (ErrorObj.type === 'In') {
          rowData.setIsInShotChangeActive(false);
        }
        if (ErrorObj.type === 'Out') {
          rowData.setIsOutShotChangeActive(false);
        }
      });

      // ，sh 的處理後，
          // 在一次檢查，如果在in-tc的上一個out 有重疊的情況發生的話就是備註
          // in-tc也會往後調整2f

          // errorShotChangeFlag:
          // 4
          // errorShotChangeTitle:
          // (1) ['00:00:04.07']
          // finalTimestring:
          // '00:00:04.07'
          // isIgnoreShotchange:
          // false
          // isInShotChangeActive:
          // false
          // isOutShotChangeActive:
          // false
          // message:
          // 'Sub 1 : Move In-TC forward (←) by 1 frames to 00:00:04.07'
          // nextIndex:
          // 1
          // outTime:
          // '00:00:04.07'
          // position:
          // '1'
          // rowIndex:
          // 0
          // second:
          // 4.333
          // shotchangeObj:
          // EveryTCobj {type: 'shotFlag', second: 4.25425, frame: 103, index: 4, inList: Array(1), …}
          // shotChangeSecond:
          // 4.25425
          // type:
          // 'In'
          
          

      // 設定ShotChange顯示
      rowData.setShotChange(chotArray.toString());

      //更新
      data[uID] = rowData;
    });

    dispatch({
      type: INIT_DATA,
      payload: data,
    });

    /**
     * @description 處理方向與標題
     * @param {*} finalFram tc建議移動到的位置
     * @param {*} targetFrame  tc目前的位置
     */
    function get_MoveArror_and_wayTitle(distance) {
      if (0 < distance) {
        //往左移
        return { moveArror: '→', wayTitle: 'backward' };
      } else {
        //往右移
        return { moveArror: '←', wayTitle: 'forward' };
      }
    }

    return data;
  };

/**
 * 設定frame要顯示 list
 * */
export const updateFindFrameTargetData =
  (data, videoFps, frameNumber) => (dispatch) => {
    // console.log(`currentOut   ${data.length}  ${videoFps}  ${frameNumber}  `);

    let newTarget = [];
    data.forEach(function (qdata, index) {
      let ROWoBJ = new DataObj(qdata);
      ROWoBJ.setTSubType(WaveformView.projectSubType);

      // 只有最後一個沒有間距
      if (index !== data.length - 1) {
        //當下資料
        const currentIn = ROWoBJ.In;
        const currentOut = ROWoBJ.Out;

        //下一個
        const nextROWoBJ = new DataObj(data[index + 1]);
        nextROWoBJ.setTSubType(WaveformView.projectSubType);

        const nextIn = nextROWoBJ.In;

        //當下frame
        const beginFrameNumber =
          TimeUtils.timeString_convertTo_frame(currentIn);
        const currentFrame = TimeUtils.timeString_convertTo_frame(currentOut);
        //下一個frame
        const nextFrame = TimeUtils.timeString_convertTo_frame(nextIn);

        //計算
        const countFrameNumber = nextFrame - currentFrame;

        //get frame number
        let durationFrame =
          parseFloat(currentFrame) - parseFloat(beginFrameNumber); //console.log(`durationFrame  ${currentFrame} - ${beginFrameNumber} = ${durationFrame}  `);
        if (
          parseFloat(currentFrame) === 0 ||
          parseFloat(beginFrameNumber) === 0
        ) {
          return;
        }

        if (nextROWoBJ.In === '') {
          return;
        }

        if (countFrameNumber < frameNumber || durationFrame < 0) {
          let frameString = TimeUtils.getTimeStringFrom_FrameCount(
            countFrameNumber,
            videoFps
          );

          newTarget.push({
            type: 'Out',
            rowIndex: index,
            nextIndex: index + 1,
            outTime: frameString,
          });
        }
      }
    });

    //更新
    dispatch({
      type: UPDATE_FRAME_SPLIT_DATA,
      payload: newTarget,
    });

    return newTarget;
  };

/**
 * 檢查 Frame Gap 要顯示 list
 * @param {*} data
 * @param {*} videoFps
 * @param {*} startGap
 * @param {*} endGap
 * @returns
 */
export const updateFindFrameGapTargetData =
  (data, videoFps, startGap, endGap) => (dispatch) => {
    let newTarget = [];
    data.forEach(function (qdata, index) {
      let ROWoBJ = new DataObj(qdata);
      ROWoBJ.setTSubType(WaveformView.projectSubType);

      // 只有最後一個沒有間距
      if (index !== data.length - 1) {
        //當下資料
        const currentIn = ROWoBJ.In;
        const currentOut = ROWoBJ.Out;

        //下一個資料
        const nextROWoBJ = data[index + 1];
        const nextIn = nextROWoBJ.In;

        //當下 frame
        const beginFrameNumber =
          TimeUtils.timeString_convertTo_frame(currentIn);
        const currentFrame = TimeUtils.timeString_convertTo_frame(currentOut);

        //下一個進點
        const nextFrame = TimeUtils.timeString_convertTo_frame(nextIn);

        //計算 當下與下一個 frame 所間隔的距離
        const countFrameNumber =
          parseFloat(nextFrame) - parseFloat(currentFrame);

        //get frame number
        let durationFrame =
          parseFloat(currentFrame) - parseFloat(beginFrameNumber);

        if (
          parseFloat(currentFrame) === 0 ||
          parseFloat(beginFrameNumber) === 0
        ) {
          return;
        }

        if (nextROWoBJ.In === '') {
          return;
        }

        //兩句字幕中間要相隔2f或12f以上
        if (
          !MathUtils.checkFrameGapIsError(countFrameNumber, startGap, endGap)
        ) {
          //沒錯 => 過關
          return;
        } else {
          let frameString = TimeUtils.getTimeStringFrom_FrameCount(
            countFrameNumber,
            videoFps
          );

          newTarget.push({
            type: 'Out',
            rowIndex: index,
            nextIndex: index + 1,
            outTime: frameString,
          });
        }
      }
    });

    //更新
    dispatch({
      type: UPDATE_FRAME_GAP_DATA,
      payload: newTarget,
    });

    return newTarget;
  };

/**
 * 檢查 CPS 要顯示 list
 * */
export const updateFindFrameCPSTargetData = (data, startCPS) => (dispatch) => {
  // console.log(`currentOut   ${data.length}  ${videoFps}  ${frameNumber}  `);

  let newTarget = [];
  data.forEach(function (qdata, index) {
    let ROWoBJ = new DataObj(qdata);
    ROWoBJ.setTSubType(WaveformView.projectSubType);

    //當下資料
    const currentCPS = ROWoBJ.CPS;
    if (currentCPS <= startCPS) {
      //過關
      return;
    } else {
      newTarget.push({
        type: 'Out',
        rowIndex: index,
        nextIndex: index + 1,
        outTime: ` (over${(currentCPS - startCPS).toFixed(1)}) ${
          ROWoBJ.SubtitleCaption
        }`,
      });
    }
  });

  //更新
  dispatch({
    type: UPDATE_FRAME_SPLIT_DATA,
    payload: newTarget,
  });

  return newTarget;
};

/**
 * 從本機取得 要檢查的frame數量
 * */
// export const get_findFrameSplitValue_from_local = () => dispatch => {
//
//     const findFrameSplitValue = localStorage.getItem('findFrameSplitValue');
//
//     dispatch({
//         type: SET_FRAME_SPLIT_VALUE,
//         payload: parseFloat(findFrameSplitValue)
//     });
//
// }

/**
 * 設定要檢查的frame數量
 * */
// export const setFrameSplitValue = (result) => dispatch => {
//
//     localStorage.setItem('findFrameSplitValue', parseFloat(result));
//     dispatch({
//         type: SET_FRAME_SPLIT_VALUE,
//         payload: result
//     });
//
// }
/**
 * 是否顯示 Position list
 * */
export const showHideFrameList = (result) => (dispatch) => {
  dispatch({
    type: SET_SHOW_FIND_FRAME,
    payload: result,
  });
};



// WEBPACK FOOTER //
// ./src/actions/find/frameFindAction.js